import { createContext, useContext, useState, useCallback, useRef, useEffect } from 'react';
import ConfirmDialog from '../components/common/ConfirmDialog.jsx';

const ConfirmContext = createContext(null);

export const ConfirmProvider = ({ children }) => {
    const [confirmState, setConfirmState] = useState({
        isOpen: false,
        title: '',
        message: '',
        variant: 'default',
        confirmText: 'Confirmar',
        cancelText: 'Cancelar'
    });
    
    const resolveRef = useRef(null);
    const [isLoading, setIsLoading] = useState(false);

    const confirm = useCallback((options) => {
        return new Promise((resolve) => {
            let title = 'Confirmação';
            let message = '';
            let variant = 'default';
            let confirmText = 'Confirmar';
            let cancelText = 'Cancelar';

            if (typeof options === 'string') {
                message = options;
            } else {
                title = options.title || title;
                message = options.message || '';
                variant = options.variant || variant;
                confirmText = options.confirmText || confirmText;
                cancelText = options.cancelText || cancelText;
            }

            setConfirmState({
                isOpen: true,
                title,
                message,
                variant,
                confirmText,
                cancelText
            });

            resolveRef.current = resolve;
        });
    }, []);

    const handleConfirm = useCallback(async () => {
        setIsLoading(true);
        try {
            if (resolveRef.current) {
                await resolveRef.current(true);
            }
        } finally {
            setIsLoading(false);
            setConfirmState(prev => ({ ...prev, isOpen: false }));
            resolveRef.current = null;
        }
    }, []);

    const handleCancel = useCallback(() => {
        if (resolveRef.current) {
            resolveRef.current(false);
            resolveRef.current = null;
        }
        setConfirmState(prev => ({ ...prev, isOpen: false }));
    }, []);

    return (
        <ConfirmContext.Provider value={confirm}>
            {children}
            <ConfirmDialog
                isOpen={confirmState.isOpen}
                title={confirmState.title}
                message={confirmState.message}
                variant={confirmState.variant}
                confirmText={confirmState.confirmText}
                cancelText={confirmState.cancelText}
                isLoading={isLoading}
                onConfirm={handleConfirm}
                onCancel={handleCancel}
            />
        </ConfirmContext.Provider>
    );
};

export const useConfirm = () => {
    const context = useContext(ConfirmContext);
    if (!context) {
        throw new Error('useConfirm deve ser usado dentro de um ConfirmProvider');
    }
    return context;
};
